import { camelize } from 'humps';

import { CALL_API } from '../middleware/api';

export const LOADING_STATISTICS = Symbol('LOADING_STATISTICS');
export const LOADING_STATISTICS_SUCCESS = Symbol('LOADING_STATISTICS_SUCCESS');
export const LOADING_STATISTICS_FAILURE = Symbol('LOADING_STATISTICS_FAILURE');
export const LOADING_BENCHMARKS = Symbol('LOADING_BENCHMARKS');
export const LOADING_BENCHMARKS_SUCCESS = Symbol('LOADING_BENCHMARKS_SUCCESS');
export const LOADING_BENCHMARKS_FAILURE = Symbol('LOADING_BENCHMARKS_FAILURE');
export const CHANGE_BENCHMARKS_ROLE_FORM = Symbol('CHANGE_BENCHMARKS_ROLE_FORM');
export const CHANGE_BENCHMARKS_TEAM_FORM = Symbol('CHANGE_BENCHMARKS_TEAM_FORM');
export const RESET_BENCHMARKS_FORM = Symbol('RESET_BENCHMARKS_FORM');
export const AUTOFILL_BENCHMARKS = Symbol('AUTOFILL_BENCHMARKS');
export const SAVE_BENCHMARKS = Symbol('SAVE_BENCHMARKS');
export const SAVE_BENCHMARKS_SUCCESS = Symbol('SAVE_BENCHMARKS_SUCCESS');
export const SAVE_BENCHMARKS_FAILURE = Symbol('SAVE_BENCHMARKS_FAILURE');
export const LOADING_DIRECTORS = Symbol('LOADING_DIRECTORS');
export const LOADING_DIRECTORS_SUCCESS = Symbol('LOADING_DIRECTORS_SUCCESS');
export const LOADING_DIRECTORS_FAILURE = Symbol('LOADING_DIRECTORS_FAILURE');
export const LOADING_DIRECTOR_TEAMS = Symbol('LOADING_DIRECTOR_TEAMS');
export const LOADING_DIRECTOR_TEAMS_SUCCESS = Symbol('LOADING_DIRECTOR_TEAMS_SUCCESS');
export const LOADING_DIRECTOR_TEAMS_FAILURE = Symbol('LOADING_DIRECTOR_TEAMS_FAILURE');
export const LOADING_USER_TITLES = Symbol('LOADING_USER_TITLES');
export const LOADING_USER_TITLES_SUCCESS = Symbol('LOADING_USER_TITLES_SUCCESS');
export const LOADING_USER_TITLES_FAILURE = Symbol('LOADING_USER_TITLES_FAILURE');
export const CREATE_TEAM = Symbol('CREATE_TEAM');
export const CREATE_TEAM_SUCCESS = Symbol('CREATE_TEAM_SUCCESS');
export const CREATE_TEAM_FAILURE = Symbol('CREATE_TEAM_FAILURE');
export const UPDATE_TEAM = Symbol('UPDATE_TEAM');
export const UPDATE_TEAM_SUCCESS = Symbol('UPDATE_TEAM_SUCCESS');
export const UPDATE_TEAM_FAILURE = Symbol('UPDATE_TEAM_FAILURE');
export const DELETE_TEAM = Symbol('DELETE_TEAM');
export const DELETE_TEAM_SUCCESS = Symbol('DELETE_TEAM_SUCCESS');
export const DELETE_TEAM_FAILURE = Symbol('DELETE_TEAM_FAILURE');
export const LOADING_USERS = Symbol('LOADING_USERS');
export const LOADING_USERS_SUCCESS = Symbol('LOADING_USERS_SUCCESS');
export const LOADING_USERS_FAILURE = Symbol('LOADING_USERS_FAILURE');
export const DELETE_USER_FROM_TEAM = Symbol('DELETE_USER_FROM_TEAM');
export const DELETE_USER_FROM_TEAM_SUCCESS = Symbol('DELETE_USER_FROM_TEAM_SUCCESS');
export const DELETE_USER_FROM_TEAM_FAILURE = Symbol('DELETE_USER_FROM_TEAM_FAILURE');
export const ADD_USER_TO_TEAM = Symbol('ADD_USER_TO_TEAM');
export const ADD_USER_TO_TEAM_SUCCESS = Symbol('ADD_USER_TO_TEAM_SUCCESS');
export const ADD_USER_TO_TEAM_FAILURE = Symbol('ADD_USER_TO_TEAM_FAILURE');
export const UPDATE_USER_TEAM = Symbol('UPDATE_USER_TEAM');
export const UPDATE_USER_TEAM_SUCCESS = Symbol('UPDATE_USER_TEAM_SUCCESS');
export const UPDATE_USER_TEAM_FAILURE = Symbol('UPDATE_USER_TEAM_FAILURE');
export const LOADING_PROJECT = Symbol('LOADING_PROJECT');
export const LOADING_PROJECT_SUCCESS = Symbol('LOADING_PROJECT_SUCCESS');
export const LOADING_PROJECT_FAILURE = Symbol('LOADING_PROJECT_FAILURE');
export const LOADING_PROJECTS = Symbol('LOADING_PROJECTS');
export const LOADING_PROJECTS_SUCCESS = Symbol('LOADING_PROJECTS_SUCCESS');
export const LOADING_PROJECTS_FAILURE = Symbol('LOADING_PROJECTS_FAILURE');
export const LOADING_PROJECT_STATISTICS = Symbol('LOADING_PROJECT_STATISTICS');
export const LOADING_PROJECT_STATISTICS_SUCCESS = Symbol('LOADING_PROJECT_STATISTICS_SUCCESS');
export const LOADING_PROJECT_STATISTICS_FAILURE = Symbol('LOADING_PROJECT_STATISTICS_FAILURE');

export function loadStatistics({ dateFrom, dateTo, comparisonDateFrom, comparisonDateTo }, showLoading = true) {
  return {
    [CALL_API]: {
      method: 'get',
      path: `/api/v1/director_dashboard/statistics?date_from=${dateFrom}&date_to=${dateTo}&comparison_date_from=${comparisonDateFrom}&comparison_date_to=${comparisonDateTo}`,
      startType: showLoading && LOADING_STATISTICS,
      successType: LOADING_STATISTICS_SUCCESS,
      errorType: LOADING_STATISTICS_FAILURE,
    },
  };
}

export function loadBenchmarks() {
  return {
    [CALL_API]: {
      method: 'get',
      path: '/api/v1/director_dashboard/benchmarks',
      startType: LOADING_BENCHMARKS,
      successType: LOADING_BENCHMARKS_SUCCESS,
      errorType: LOADING_BENCHMARKS_FAILURE,
    },
  };
}

export function changeRoleForm({ id, key, value }) {
  return {
    type: CHANGE_BENCHMARKS_ROLE_FORM,
    id,
    key,
    value,
  };
}

export function changeTeamForm({ id, key, value }) {
  return {
    type: CHANGE_BENCHMARKS_TEAM_FORM,
    id,
    key,
    value,
  };
}

export function resetForm() {
  return {
    type: RESET_BENCHMARKS_FORM,
  };
}

/**
 * Fill all role benchmarks with the given metric value.
 *
 * @param {string} averageKey Metric field to copy into benchmarks: `'avg'`, `'firmWideBenchmark'` or `'moduleAvg'`.
 */
export const autofillBenchmarks = averageKey => ({
  type: AUTOFILL_BENCHMARKS,
  averageKey,
});

export function updateBenchmarks({ benchmarks, afterSuccess }) {
  const roleEntries = benchmarks
    .get('roles')
    .flatMap(role =>
      benchmarks.get('roleColumns').map(column => ({
        title_id: role.get('titleId'),
        metric_key: column.get('key'),
        value: role.getIn(['metrics', camelize(column.get('key')), 'benchmark']),
      })),
    )
    .toArray();

  const body = {
    benchmarks: [...roleEntries],
  };

  return {
    [CALL_API]: {
      method: 'put',
      path: '/api/v1/director_dashboard/benchmarks',
      body,
      skipGlobalErrorHandler: true,
      afterSuccess,
      startType: SAVE_BENCHMARKS,
      successType: SAVE_BENCHMARKS_SUCCESS,
      errorType: SAVE_BENCHMARKS_FAILURE,
    },
  };
}

export function shareLink(body, { afterSuccess = () => {}, afterError = () => {} }) {
  return {
    [CALL_API]: {
      method: 'post',
      path: '/api/v1/director_dashboard/statistics/share_link',
      body,
      skipGlobalErrorHandler: true,
      afterSuccess,
      afterError,
    },
  };
}

export function loadDirectors() {
  return {
    [CALL_API]: {
      method: 'get',
      path: '/api/v1/director_dashboard/directors',
      startType: LOADING_DIRECTORS,
      successType: LOADING_DIRECTORS_SUCCESS,
      errorType: LOADING_DIRECTORS_FAILURE,
    },
  };
}

export function loadDirectorTeams(directorUserId) {
  return {
    [CALL_API]: {
      method: 'get',
      path: `/api/v1/director_dashboard/directors/${directorUserId}`,
      startType: LOADING_DIRECTOR_TEAMS,
      successType: LOADING_DIRECTOR_TEAMS_SUCCESS,
      errorType: LOADING_DIRECTOR_TEAMS_FAILURE,
    },
  };
}

export function loadUserTitles() {
  return {
    [CALL_API]: {
      method: 'get',
      path: '/api/v1/director_dashboard/user_titles',
      startType: LOADING_USER_TITLES,
      successType: LOADING_USER_TITLES_SUCCESS,
      errorType: LOADING_USER_TITLES_FAILURE,
    },
  };
}

export function loadUsers(directorUserId) {
  return {
    [CALL_API]: {
      method: 'get',
      path: `/api/v1/users?module_id=${directorUserId}`,
      startType: LOADING_USERS,
      successType: LOADING_USERS_SUCCESS,
      errorType: LOADING_USERS_FAILURE,
    },
  };
}

export function addUsersToTeam({ directorUserId, body, afterSuccess = () => {}, afterError = () => {} }) {
  return {
    [CALL_API]: {
      method: 'post',
      path: `/api/v1/director_dashboard/directors/${directorUserId}/memberships`,
      body,
      startType: ADD_USER_TO_TEAM,
      successType: ADD_USER_TO_TEAM_SUCCESS,
      errorType: ADD_USER_TO_TEAM_FAILURE,
      afterSuccess,
      afterError,
    },
  };
}

export function updateUserTeam({ directorUserId, membershipId, body, afterSuccess = () => {}, afterError = () => {} }) {
  return {
    [CALL_API]: {
      method: 'put',
      body,
      path: `/api/v1/director_dashboard/directors/${directorUserId}/memberships/${membershipId}`,
      startType: UPDATE_USER_TEAM,
      successType: UPDATE_USER_TEAM_SUCCESS,
      errorType: UPDATE_USER_TEAM_FAILURE,
      afterSuccess,
      afterError,
    },
  };
}

export function deleteUserFromTeam({ directorUserId, membershipId, afterSuccess = () => {}, afterError = () => {} }) {
  return {
    [CALL_API]: {
      method: 'delete',
      path: `/api/v1/director_dashboard/directors/${directorUserId}/memberships/${membershipId}`,
      startType: DELETE_USER_FROM_TEAM,
      successType: DELETE_USER_FROM_TEAM_SUCCESS,
      errorType: DELETE_USER_FROM_TEAM_FAILURE,
      afterSuccess,
      afterError,
    },
  };
}

export function createTeam({ directorUserId, body, afterSuccess = () => {}, afterError = () => {} }) {
  return {
    [CALL_API]: {
      method: 'post',
      path: `/api/v1/director_dashboard/directors/${directorUserId}/teams`,
      body,
      afterSuccess,
      afterError,
      startType: CREATE_TEAM,
      successType: CREATE_TEAM_SUCCESS,
      errorType: CREATE_TEAM_FAILURE,
    },
  };
}

export function updateTeam({ directorUserId, teamId, body, afterSuccess = () => {}, afterError = () => {} }) {
  return {
    [CALL_API]: {
      method: 'put',
      body,
      path: `/api/v1/director_dashboard/directors/${directorUserId}/teams/${teamId}`,
      startType: UPDATE_TEAM,
      successType: UPDATE_TEAM_SUCCESS,
      errorType: UPDATE_TEAM_FAILURE,
      afterSuccess,
      afterError,
    },
  };
}

export function deleteTeam({ directorUserId, teamId, afterSuccess = () => {}, afterError = () => {} }) {
  return {
    [CALL_API]: {
      method: 'delete',
      path: `/api/v1/director_dashboard/directors/${directorUserId}/teams/${teamId}`,
      startType: DELETE_TEAM,
      successType: DELETE_TEAM_SUCCESS,
      errorType: DELETE_TEAM_FAILURE,
      afterSuccess,
      afterError,
    },
  };
}

export function loadProjects({ page, limit = 20, search, active }) {
  const activeParam = active ? `&active=${active}` : '';
  const searchParam = search ? `&search=${search}` : '';

  return {
    page,
    [CALL_API]: {
      method: 'get',
      path: `/api/v1/director_dashboard/projects?page=${page}&limit=${limit}${searchParam}${activeParam}`,
      unifier: 'director_dashboard_projects',
      dislodging: true,
      startType: LOADING_PROJECTS,
      successType: LOADING_PROJECTS_SUCCESS,
      errorType: LOADING_PROJECTS_FAILURE,
    },
  };
}

export function loadProject(projectId, showLoading = true) {
  return {
    [CALL_API]: {
      method: 'get',
      path: `/api/v1/director_dashboard/projects/${projectId}/data`,
      unifier: 'director_dashboard_project',
      dislodging: true,
      startType: showLoading && LOADING_PROJECT,
      successType: LOADING_PROJECT_SUCCESS,
      errorType: LOADING_PROJECT_FAILURE,
    },
  };
}

export function loadProjectStatistics({ projectId, dateFrom, dateTo }, showLoading = true) {
  return {
    [CALL_API]: {
      method: 'get',
      path: `/api/v1/director_dashboard/projects/${projectId}/statistics?date_from=${dateFrom}&date_to=${dateTo}`,
      unifier: 'director_dashboard_project_statistics',
      dislodging: true,
      startType: showLoading && LOADING_PROJECT_STATISTICS,
      successType: LOADING_PROJECT_STATISTICS_SUCCESS,
      errorType: LOADING_PROJECT_STATISTICS_FAILURE,
    },
  };
}

export function shareProjectLink({ projectId, ...body }, { afterSuccess = () => {}, afterError = () => {} }) {
  return {
    [CALL_API]: {
      method: 'post',
      path: `/api/v1/director_dashboard/projects/${projectId}/statistics/share_link`,
      body,
      skipGlobalErrorHandler: true,
      afterSuccess,
      afterError,
    },
  };
}
